export const FACEBOOK_ICONS = {
  book: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 15.75L8.92496 15.6374C8.40398 14.856 8.14349 14.4652 7.79933 14.1824C7.49464 13.9319 7.14357 13.7441 6.7662 13.6295C6.33994 13.5 5.87033 13.5 4.93112 13.5H3.9C3.05992 13.5 2.63988 13.5 2.31901 13.3365C2.03677 13.1927 1.8073 12.9632 1.66349 12.681C1.5 12.3601 1.5 11.9401 1.5 11.1V4.65C1.5 3.80992 1.5 3.38988 1.66349 3.06901C1.8073 2.78677 2.03677 2.5573 2.31901 2.41349C2.63988 2.25 3.05992 2.25 3.9 2.25H4.2C5.88016 2.25 6.72024 2.25 7.36197 2.57698C7.92646 2.8646 8.3854 3.32354 8.67302 3.88803C9 4.52976 9 5.36984 9 7.05M9 15.75V7.05M9 15.75L9.07504 15.6374C9.59602 14.856 9.85651 14.4652 10.2007 14.1824C10.5054 13.9319 10.8564 13.7441 11.2338 13.6295C11.6601 13.5 12.1297 13.5 13.0689 13.5H14.1C14.9401 13.5 15.3601 13.5 15.681 13.3365C15.9632 13.1927 16.1927 12.9632 16.3365 12.681C16.5 12.3601 16.5 11.9401 16.5 11.1V4.65C16.5 3.80992 16.5 3.38988 16.3365 3.06901C16.1927 2.78677 15.9632 2.5573 15.681 2.41349C15.3601 2.25 14.9401 2.25 14.1 2.25H13.8C12.1198 2.25 11.2798 2.25 10.638 2.57698C10.0735 2.8646 9.6146 3.32354 9.32698 3.88803C9 4.52976 9 5.36984 9 7.05"
        stroke="#7C88A6"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chat: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8626_146873)">
        <path
          d="M7.5 11.25L5.19356 13.5853C4.87184 13.911 4.71098 14.0739 4.57271 14.0854C4.45276 14.0953 4.33531 14.0471 4.25697 13.9557C4.16667 13.8504 4.16667 13.6215 4.16667 13.1637V11.9937C4.16667 11.583 3.83031 11.2858 3.4239 11.2262V11.2262C2.44031 11.0822 1.66783 10.3097 1.52376 9.3261C1.5 9.16391 1.5 8.97039 1.5 8.58333V5.1C1.5 3.83988 1.5 3.20982 1.74524 2.72852C1.96095 2.30516 2.30516 1.96095 2.72852 1.74524C3.20982 1.5 3.83988 1.5 5.1 1.5H10.65C11.9101 1.5 12.5402 1.5 13.0215 1.74524C13.4448 1.96095 13.789 2.30516 14.0048 2.72852C14.25 3.20982 14.25 3.83988 14.25 5.1V8.25M14.25 16.5L12.6177 15.3652C12.3882 15.2056 12.2735 15.1259 12.1487 15.0693C12.0378 15.0191 11.9213 14.9826 11.8017 14.9606C11.6669 14.9357 11.5271 14.9357 11.2477 14.9357H9.9C9.05992 14.9357 8.63988 14.9357 8.31901 14.7722C8.03677 14.6284 7.8073 14.3989 7.66349 14.1167C7.5 13.7958 7.5 13.3758 7.5 12.5357V10.65C7.5 9.80992 7.5 9.38988 7.66349 9.06901C7.8073 8.78677 8.03677 8.5573 8.31901 8.41349C8.63988 8.25 9.05992 8.25 9.9 8.25H14.1C14.9401 8.25 15.3601 8.25 15.681 8.41349C15.9632 8.5573 16.1927 8.78677 16.3365 9.06901C16.5 9.38988 16.5 9.80992 16.5 10.65V12.6857C16.5 13.3846 16.5 13.7341 16.3858 14.0097C16.2336 14.3773 15.9416 14.6693 15.574 14.8215C15.2984 14.9357 14.9489 14.9357 14.25 14.9357V16.5Z"
          stroke="#7C88A6"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8626_146873">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  mess: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 12.5256C8 13.4357 8 13.8908 8.16349 14.2385C8.3073 14.5443 8.53677 14.7929 8.81902 14.9487C9.13988 15.1258 9.55992 15.1258 10.4 15.1258H11.6581C11.9702 15.1258 12.1262 15.1258 12.2754 15.159C12.4078 15.1884 12.5359 15.2371 12.6563 15.3037C12.7919 15.3788 12.9137 15.4844 13.1574 15.6956L14.3501 16.7294C14.5582 16.9097 14.6622 16.9999 14.7497 17C14.8259 17.0001 14.8979 16.9626 14.9454 16.8981C15 16.824 15 16.6797 15 16.391V15.1258C15.465 15.1258 15.6975 15.1258 15.8882 15.0704C16.4059 14.9202 16.8102 14.4821 16.9489 13.9213C17 13.7146 17 13.4627 17 12.9589V9.60026C17 8.69008 17 8.235 16.8365 7.88735C16.6927 7.58156 16.4632 7.33294 16.181 7.17713C15.8601 7 15.4401 7 14.6 7H13"
          stroke="#7C88A6"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 5.38034C1 4.19711 1 3.60549 1.21799 3.15356C1.40973 2.75603 1.71569 2.43282 2.09202 2.23027C2.51984 2 3.07989 2 4.2 2H9.8C10.9201 2 11.4802 2 11.908 2.23027C12.2843 2.43282 12.5903 2.75603 12.782 3.15356C13 3.60549 13 4.19711 13 5.38034V9.18322C13 10.3664 13 10.9581 12.782 11.41C12.5903 11.8075 12.2843 12.1307 11.908 12.3333C11.4802 12.5636 10.9201 12.5636 9.8 12.5636H8.1225C7.70646 12.5636 7.49845 12.5636 7.29948 12.6067C7.12295 12.645 6.95213 12.7083 6.79166 12.7949C6.61078 12.8925 6.44834 13.0298 6.12348 13.3043L4.53317 14.6482C4.25578 14.8827 4.11708 14.9999 4.00036 15C3.89885 15.0001 3.80282 14.9514 3.73949 14.8676C3.66667 14.7712 3.66667 14.5836 3.66667 14.2083V12.5636C3.04669 12.5636 2.73669 12.5636 2.48236 12.4916C1.79218 12.2962 1.25308 11.7267 1.06815 10.9977C1 10.729 1 10.4015 1 9.74661V5.38034Z"
          stroke="#7C88A6"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.55263 4.36953V5.61746C7.55263 5.70156 7.48833 5.77246 7.40511 5.78461C4.69804 6.17977 4.34902 7.91956 4 10C4.54073 7.85121 6.4103 7.44844 7.40672 7.51557C7.49063 7.52123 7.55263 7.59256 7.55263 7.67666V8.95471C7.55263 9.09316 7.71165 9.17124 7.8212 9.08659L10.5904 6.94684C10.6732 6.88286 10.6773 6.7593 10.5988 6.69003L7.82962 4.2446C7.72202 4.14958 7.55263 4.22598 7.55263 4.36953Z"
          stroke="#7C88A6"
          stroke-width="0.9"
        />
      </svg>
    ),
  chatCircleDots: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25649 18.9281L4.22837 21.4594C4.1191 21.5498 3.98644 21.6074 3.84577 21.6254C3.7051 21.6435 3.56219 21.6213 3.43362 21.5615C3.30506 21.5016 3.1961 21.4065 3.11939 21.2872C3.04268 21.1679 3.00137 21.0293 3.00024 20.8875V6C3.00024 5.80109 3.07926 5.61032 3.21991 5.46967C3.36057 5.32902 3.55133 5.25 3.75024 5.25H20.2502C20.4492 5.25 20.6399 5.32902 20.7806 5.46967C20.9212 5.61032 21.0002 5.80109 21.0002 6V18C21.0002 18.1989 20.9212 18.3897 20.7806 18.5303C20.6399 18.671 20.4492 18.75 20.2502 18.75H7.73462C7.55903 18.75 7.38931 18.8133 7.25649 18.9281Z"
        stroke="#00081D"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0002 13.125C12.6216 13.125 13.1252 12.6213 13.1252 12C13.1252 11.3787 12.6216 10.875 12.0002 10.875C11.3789 10.875 10.8752 11.3787 10.8752 12C10.8752 12.6213 11.3789 13.125 12.0002 13.125Z"
        fill="currentColor"
      />
      <path
        d="M7.50024 13.125C8.12156 13.125 8.62524 12.6213 8.62524 12C8.62524 11.3787 8.12156 10.875 7.50024 10.875C6.87892 10.875 6.37524 11.3787 6.37524 12C6.37524 12.6213 6.87892 13.125 7.50024 13.125Z"
        fill="currentColor"
      />
      <path
        d="M16.5002 13.125C17.1216 13.125 17.6252 12.6213 17.6252 12C17.6252 11.3787 17.1216 10.875 16.5002 10.875C15.8789 10.875 15.3752 11.3787 15.3752 12C15.3752 12.6213 15.8789 13.125 16.5002 13.125Z"
        fill="currentColor"
      />
    </svg>
  ),
  checked: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="9" fill="#1A94FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7931 5.17114C14.0497 5.41745 14.0705 5.83898 13.8396 6.11265L8.21456 12.7793C8.09603 12.9198 7.92718 13 7.75 13C7.57282 13 7.40397 12.9198 7.28544 12.7793L4.16045 9.07561C3.92953 8.80194 3.95033 8.38041 4.2069 8.1341C4.46347 7.8878 4.85865 7.90998 5.08956 8.18366L7.75 11.3368L12.9104 5.2207C13.1413 4.94702 13.5365 4.92484 13.7931 5.17114Z"
        fill="white"
      />
    </svg>
  ),
  unchecked: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7931 5.17114C14.0497 5.41745 14.0705 5.83898 13.8396 6.11265L8.21456 12.7793C8.09603 12.9198 7.92718 13 7.75 13C7.57282 13 7.40397 12.9198 7.28544 12.7793L4.16045 9.07561C3.92953 8.80194 3.95033 8.38041 4.2069 8.1341C4.46347 7.8878 4.85865 7.90998 5.08956 8.18366L7.75 11.3368L12.9104 5.2207C13.1413 4.94702 13.5365 4.92484 13.7931 5.17114Z"
        fill="white"
      />
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#191D32" />
      <rect
        x="0.5"
        y="0.5"
        width="17"
        height="17"
        rx="8.5"
        stroke="#F4F7FC"
        strokeOpacity="0.8"
      />
    </svg>
  ),
  chevronDown: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.495 8.49497C14.7683 8.22161 14.7683 7.77839 14.495 7.50502C14.2216 7.23166 13.7784 7.23166 13.505 7.50502L14.495 8.49497ZM10 12L9.50503 12.495C9.77839 12.7683 10.2216 12.7683 10.495 12.495L10 12ZM6.49497 7.50502C6.22161 7.23166 5.77839 7.23166 5.50503 7.50502C5.23166 7.77839 5.23166 8.22161 5.50503 8.49497L6.49497 7.50502ZM13.505 7.50502L9.50503 11.505L10.495 12.495L14.495 8.49497L13.505 7.50502ZM10.495 11.505L6.49497 7.50502L5.50503 8.49497L9.50503 12.495L10.495 11.505Z"
        fill="white"
      />
    </svg>
  ),
  edit05: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 2.99993H5.1C3.83988 2.99993 3.20982 2.99993 2.72852 3.24516C2.30516 3.46088 1.96095 3.80508 1.74524 4.22845C1.5 4.70975 1.5 5.33981 1.5 6.59993V12.8999C1.5 14.16 1.5 14.7901 1.74524 15.2714C1.96095 15.6948 2.30516 16.039 2.72852 16.2547C3.20982 16.4999 3.83988 16.4999 5.1 16.4999H11.4C12.6601 16.4999 13.2902 16.4999 13.7715 16.2547C14.1948 16.039 14.539 15.6948 14.7548 15.2714C15 14.7901 15 14.16 15 12.8999V9.74993M5.99998 11.9999H7.25589C7.62277 11.9999 7.80622 11.9999 7.97885 11.9585C8.1319 11.9217 8.27822 11.8611 8.41243 11.7789C8.5638 11.6861 8.69352 11.5564 8.95294 11.297L16.125 4.12493C16.7463 3.50361 16.7463 2.49625 16.125 1.87493C15.5037 1.25361 14.4963 1.25361 13.875 1.87492L6.70293 9.04698C6.4435 9.30641 6.31378 9.43612 6.22102 9.5875C6.13878 9.72171 6.07817 9.86802 6.04143 10.0211C5.99998 10.1937 5.99998 10.3772 5.99998 10.744V11.9999Z"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  facebook: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11C22 4.92474 17.0753 0 11 0C4.92474 0 0 4.92474 0 11C0 16.4902 4.02193 21.0418 9.28074 21.8664V14.1794H6.48756V11H9.28074V8.57674C9.28074 5.81941 10.9234 4.29733 13.4363 4.29733C14.6406 4.29733 15.8987 4.51244 15.8987 4.51244V7.21926H14.5119C13.1446 7.21926 12.7193 8.06667 12.7193 8.93689V11H15.7699L15.2827 14.1794H12.7193V21.8664C17.9781 21.0418 22 16.4902 22 11Z"
        fill="white"
      />
      <path
        d="M15.2808 14.1794L15.768 11H12.719V8.93692C12.719 8.0667 13.1443 7.21929 14.5116 7.21929H15.8984V4.51247C15.8984 4.51247 14.6403 4.29736 13.436 4.29736C10.9232 4.29736 9.28049 5.81944 9.28049 8.57677V11H6.4873V14.1794H9.28049V21.8664C9.84108 21.9544 10.4147 22 10.9997 22C11.5848 22 12.1584 21.9544 12.719 21.8664V14.1794H15.2808Z"
        fill="#2374E1"
      />
    </svg>
  ),
  facebookAnchor: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8730_25907)">
        <path
          d="M12.1621 18.7292C11.3417 18.7292 10.5213 18.7292 9.6967 18.7292C9.6967 16.5907 9.6967 14.4521 9.6967 12.3049C9.50442 12.3049 9.3207 12.3049 9.13269 12.3049C8.94469 12.3049 8.75669 12.3049 8.57297 12.3049C8.38496 12.3049 8.19696 12.3049 8.01324 12.3049C8.00042 12.2664 7.99614 10.0807 8.00469 9.96495L8.00896 9.96066L8.01324 9.95638H8.01751C8.02178 9.95638 8.02605 9.95638 8.0346 9.95638C8.58151 9.95638 9.13269 9.95638 9.67961 9.95638C9.67961 9.95638 9.68388 9.95638 9.69242 9.95209C9.69242 9.93495 9.69242 9.91352 9.69242 9.89209C9.69242 9.31352 9.69242 8.73495 9.69242 8.16066C9.69242 7.98923 9.69242 7.82209 9.70952 7.65066C9.8377 6.51923 10.4017 5.70923 11.4656 5.27209C11.7604 5.15209 12.0681 5.07923 12.3843 5.04066C12.7175 4.99781 13.0508 4.99352 13.3841 5.00638C13.6362 5.01495 13.8883 5.02781 14.1361 5.04066C14.2942 5.04923 14.4523 5.07066 14.6104 5.08352C14.6232 5.08352 14.636 5.08781 14.6574 5.09209C14.6403 5.82066 14.6189 6.54495 14.6018 7.27781C14.5762 7.27781 14.5548 7.27781 14.5292 7.27781C14.0592 7.27781 13.5892 7.27352 13.1192 7.27352C12.991 7.27352 12.8585 7.27781 12.7303 7.30781C12.709 7.31209 12.6876 7.31638 12.6663 7.32495C12.4056 7.39781 12.2518 7.56923 12.1963 7.83495C12.1663 7.97209 12.1578 8.10923 12.1578 8.25066C12.1578 8.79923 12.1578 9.34781 12.1578 9.89638C12.1578 9.91352 12.1578 9.92638 12.1621 9.95209C12.9953 9.95209 13.8284 9.95209 14.6659 9.95209C14.6274 10.7364 14.5933 11.5164 14.5548 12.3007C13.7558 12.3007 12.9611 12.3007 12.1749 12.3007C12.1706 12.3049 12.1663 12.3049 12.1663 12.3092C12.1663 12.3092 12.1663 12.3135 12.1621 12.3135V12.3178V12.3221C12.1621 12.3264 12.1621 12.3307 12.1621 12.3307V12.3349V12.3392C12.1621 12.3435 12.1621 12.3521 12.1621 12.3564C12.1621 14.4649 12.1621 16.5778 12.1621 18.6864V18.6907C12.1621 18.6949 12.1621 18.6992 12.1621 18.7035V18.7078V18.7121C12.1663 18.7249 12.1663 18.7249 12.1621 18.7292Z"
          fill="#00081D"
        />
        <path
          d="M21.4834 15.1818C21.8186 14.1823 22.0002 13.1124 22.0002 12C22.0002 6.47715 17.5231 2 12.0002 2C6.4774 2 2.00024 6.47715 2.00024 12C2.00024 17.5228 6.4774 22 12.0002 22C12.9457 22 13.8606 21.8688 14.7275 21.6236"
          stroke="#00081D"
          strokeLinecap="round"
        />
        <path
          d="M19.9509 20.9018L21.4795 20.9018C21.9658 20.9018 22.4322 20.7049 22.7761 20.3546C23.12 20.0043 23.3132 19.5291 23.3132 19.0336C23.3132 18.5382 23.12 18.063 22.7761 17.7127C22.4322 17.3623 21.9658 17.1655 21.4795 17.1655L19.9509 17.1655"
          stroke="#00081D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1218 20.9037L16.5933 20.9037C16.3525 20.9037 16.114 20.8554 15.8915 20.7615C15.6691 20.6676 15.4669 20.53 15.2966 20.3565C14.9528 20.0062 14.7596 19.531 14.7596 19.0356C14.7596 18.5401 14.9528 18.065 15.2966 17.7146C15.6405 17.3643 16.107 17.1675 16.5933 17.1675L18.1218 17.1675"
          stroke="#00081D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2021 19.0328L20.868 19.03"
          stroke="#00081D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8730_25907">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  gearSix: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4013 9.56712C21.3791 9.46731 21.3358 9.37343 21.2742 9.29183C21.2126 9.21022 21.1342 9.1428 21.0443 9.09411L18.9203 7.91607C18.8072 7.68403 18.6823 7.46092 18.5454 7.24673L18.5811 4.81925C18.582 4.71743 18.5618 4.61653 18.5219 4.52287C18.4819 4.4292 18.4231 4.34477 18.3491 4.27485C17.2915 3.31596 16.0408 2.59474 14.6811 2.15972C14.5835 2.12928 14.4805 2.1199 14.3789 2.13221C14.2774 2.14451 14.1796 2.17823 14.0921 2.23112L12.0127 3.48056C11.7539 3.47164 11.504 3.47164 11.2451 3.48056L9.16573 2.23112C9.07818 2.17823 8.98041 2.14451 8.87888 2.13221C8.77734 2.1199 8.67435 2.12928 8.5767 2.15972C7.21523 2.59507 5.96398 3.31964 4.90871 4.28377C4.83405 4.35129 4.77471 4.43401 4.73468 4.52637C4.69466 4.61874 4.67488 4.7186 4.67667 4.81925L4.72129 7.24673C4.5785 7.46092 4.45355 7.68403 4.32861 7.91607L2.21349 9.09411C2.12246 9.14133 2.04316 9.20831 1.98139 9.29016C1.91962 9.372 1.87695 9.46664 1.8565 9.56712C1.55304 10.9609 1.55304 12.4036 1.8565 13.7974C1.87867 13.8972 1.92202 13.991 1.9836 14.0726C2.04519 14.1543 2.12359 14.2217 2.21349 14.2704L4.33753 15.4484C4.4514 15.6793 4.57957 15.9028 4.72129 16.1177L4.67667 18.5452C4.67585 18.647 4.69604 18.7479 4.73596 18.8416C4.77588 18.9353 4.83469 19.0197 4.90871 19.0896C5.96776 20.0465 7.21803 20.7675 8.5767 21.2048C8.67435 21.2352 8.77734 21.2446 8.87888 21.2323C8.98041 21.22 9.07818 21.1862 9.16573 21.1334L11.2451 19.8839H12.0127L14.101 21.1334C14.2096 21.2047 14.337 21.242 14.4669 21.2405C14.5395 21.2373 14.6114 21.2253 14.6811 21.2048C16.0426 20.7694 17.2938 20.0448 18.3491 19.0807C18.4238 19.0132 18.4831 18.9305 18.5231 18.8381C18.5632 18.7457 18.5829 18.6459 18.5811 18.5452L18.5454 16.1177C18.6793 15.9036 18.8043 15.6804 18.9292 15.4484L21.0533 14.2704C21.1419 14.2212 21.2188 14.1535 21.2789 14.0718C21.3389 13.9902 21.3807 13.8966 21.4013 13.7974C21.7048 12.4036 21.7048 10.9609 21.4013 9.56712V9.56712ZM15.5557 11.6822C15.5557 12.4589 15.3254 13.2181 14.8939 13.8639C14.4624 14.5096 13.8492 15.0129 13.1316 15.3101C12.4141 15.6073 11.6246 15.6851 10.8628 15.5336C10.1011 15.3821 9.40141 15.0081 8.85223 14.4589C8.30306 13.9097 7.92907 13.21 7.77755 12.4483C7.62603 11.6866 7.7038 10.897 8.00101 10.1795C8.29822 9.46198 8.80153 8.8487 9.44729 8.41722C10.093 7.98573 10.8523 7.75543 11.6289 7.75543C12.6704 7.75543 13.6692 8.16914 14.4056 8.90556C15.142 9.64198 15.5557 10.6408 15.5557 11.6822Z"
        fill="white"
      />
    </svg>
  ),
  gearSix2: (
     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M9.39504 19.3711L9.97949 20.6856C10.1532 21.0768 10.4368 21.4093 10.7957 21.6426C11.1547 21.8759 11.5736 22.0001 12.0017 22C12.4298 22.0001 12.8488 21.8759 13.2077 21.6426C13.5667 21.4093 13.8502 21.0768 14.0239 20.6856L14.6084 19.3711C14.8164 18.9047 15.1664 18.5159 15.6084 18.26C16.0532 18.0034 16.5677 17.8941 17.0784 17.9478L18.5084 18.1C18.934 18.145 19.3636 18.0656 19.7451 17.8713C20.1265 17.6771 20.4434 17.3763 20.6573 17.0056C20.8714 16.635 20.9735 16.2103 20.951 15.7829C20.9285 15.3555 20.7825 14.9438 20.5306 14.5978L19.6839 13.4344C19.3825 13.0171 19.2214 12.5148 19.2239 12C19.2238 11.4866 19.3864 10.9864 19.6884 10.5711L20.535 9.40778C20.7869 9.06175 20.933 8.65007 20.9554 8.22267C20.9779 7.79528 20.8759 7.37054 20.6617 7C20.4478 6.62923 20.1309 6.32849 19.7495 6.13423C19.3681 5.93997 18.9385 5.86053 18.5128 5.90556L17.0828 6.05778C16.5722 6.11141 16.0576 6.00212 15.6128 5.74556C15.1699 5.48825 14.8199 5.09736 14.6128 4.62889L14.0239 3.31444C13.8502 2.92317 13.5667 2.59072 13.2077 2.3574C12.8488 2.12408 12.4298 1.99993 12.0017 2C11.5736 1.99993 11.1547 2.12408 10.7957 2.3574C10.4368 2.59072 10.1532 2.92317 9.97949 3.31444L9.39504 4.62889C9.18797 5.09736 8.83792 5.48825 8.39504 5.74556C7.95026 6.00212 7.43571 6.11141 6.92504 6.05778L5.4906 5.90556C5.06493 5.86053 4.63534 5.93997 4.25391 6.13423C3.87249 6.32849 3.55561 6.62923 3.34171 7C3.12753 7.37054 3.02549 7.79528 3.04798 8.22267C3.07046 8.65007 3.2165 9.06175 3.46838 9.40778L4.31504 10.5711C4.61698 10.9864 4.77958 11.4866 4.77949 12C4.77958 12.5134 4.61698 13.0137 4.31504 13.4289L3.46838 14.5922C3.2165 14.9382 3.07046 15.3499 3.04798 15.7773C3.02549 16.2047 3.12753 16.6295 3.34171 17C3.55582 17.3706 3.87274 17.6712 4.25411 17.8654C4.63548 18.0596 5.06496 18.1392 5.4906 18.0944L6.9206 17.9422C7.43127 17.8886 7.94581 17.9979 8.3906 18.2544C8.83513 18.511 9.18681 18.902 9.39504 19.3711Z" stroke="#00081D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
       <path d="M11.9999 15C13.6568 15 14.9999 13.6569 14.9999 12C14.9999 10.3431 13.6568 9 11.9999 9C10.3431 9 8.99992 10.3431 8.99992 12C8.99992 13.6569 10.3431 15 11.9999 15Z" stroke="#00081D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
     </svg>
  ),
  handBag: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5923 19.3302L20.3566 8.26924C20.3202 7.93087 20.1596 7.61803 19.9057 7.39134C19.6519 7.16464 19.323 7.04022 18.9826 7.04217H16.0878C15.9214 6.07873 15.4201 5.20502 14.6722 4.57524C13.9244 3.94546 12.9781 3.6001 12.0004 3.6001C11.0227 3.6001 10.0764 3.94546 9.32857 4.57524C8.58072 5.20502 8.07938 6.07873 7.91301 7.04217H5.01815C4.67783 7.04022 4.34889 7.16464 4.09506 7.39134C3.84122 7.61803 3.68055 7.93087 3.64417 8.26924L2.40845 19.3302C2.38752 19.5244 2.40746 19.7208 2.46699 19.9069C2.52652 20.0929 2.62432 20.2644 2.75411 20.4104C2.88346 20.555 3.04197 20.6706 3.21921 20.7495C3.39645 20.8285 3.58841 20.869 3.78243 20.8684H20.2184C20.4124 20.869 20.6043 20.8285 20.7816 20.7495C20.9588 20.6706 21.1173 20.555 21.2467 20.4104C21.3765 20.2644 21.4743 20.0929 21.5338 19.9069C21.5933 19.7208 21.6133 19.5244 21.5923 19.3302ZM9.23515 10.4987C9.23515 10.6821 9.16231 10.8579 9.03267 10.9876C8.90302 11.1172 8.72718 11.19 8.54384 11.19C8.36049 11.19 8.18465 11.1172 8.05501 10.9876C7.92536 10.8579 7.85253 10.6821 7.85253 10.4987V9.1161C7.85253 8.93275 7.92536 8.75692 8.05501 8.62727C8.18465 8.49762 8.36049 8.42479 8.54384 8.42479C8.72718 8.42479 8.90302 8.49762 9.03267 8.62727C9.16231 8.75692 9.23515 8.93275 9.23515 9.1161V10.4987ZM9.32156 7.04217C9.47386 6.44735 9.81979 5.92014 10.3048 5.54365C10.7899 5.16717 11.3864 4.96281 12.0004 4.96281C12.6144 4.96281 13.2109 5.16717 13.696 5.54365C14.181 5.92014 14.5269 6.44735 14.6792 7.04217H9.32156ZM16.1483 10.4987C16.1483 10.6821 16.0754 10.8579 15.9458 10.9876C15.8161 11.1172 15.6403 11.19 15.4569 11.19C15.2736 11.19 15.0978 11.1172 14.9681 10.9876C14.8385 10.8579 14.7656 10.6821 14.7656 10.4987V9.1161C14.7656 8.93275 14.8385 8.75692 14.9681 8.62727C15.0978 8.49762 15.2736 8.42479 15.4569 8.42479C15.6403 8.42479 15.8161 8.49762 15.9458 8.62727C16.0754 8.75692 16.1483 8.93275 16.1483 9.1161V10.4987Z"
        fill="#00AB56"
      />
    </svg>
  ),
  handBag01: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.841 6.88135H4.15945C3.96843 6.88224 3.78427 6.95268 3.6414 7.07947C3.49852 7.20627 3.40672 7.38076 3.38314 7.57033L2.00517 19.9914C1.99292 20.0996 2.00357 20.2092 2.03645 20.313C2.06932 20.4169 2.12367 20.5126 2.19597 20.5941C2.26828 20.6755 2.35691 20.7409 2.45612 20.7858C2.55532 20.8308 2.66287 20.8544 2.77179 20.855H21.2287C21.3376 20.8544 21.4452 20.8308 21.5444 20.7858C21.6436 20.7409 21.7322 20.6755 21.8045 20.5941C21.8768 20.5126 21.9312 20.4169 21.964 20.313C21.9969 20.2092 22.0076 20.0996 21.9953 19.9914L20.6174 7.57033C20.5938 7.38076 20.502 7.20627 20.3591 7.07947C20.2162 6.95268 20.0321 6.88224 19.841 6.88135V6.88135Z"
        stroke="#00081D"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.11877 9.98684V6.88158C8.11877 5.85212 8.52773 4.86483 9.25566 4.13689C9.9836 3.40895 10.9709 3 12.0004 3C13.0298 3 14.0171 3.40895 14.745 4.13689C15.473 4.86483 15.8819 5.85212 15.8819 6.88158V9.98684"
        stroke="#00081D"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  hidden: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.05721 3.81924C8.36202 3.77417 8.67645 3.75 9.00031 3.75C12.8291 3.75 15.3415 7.12863 16.1855 8.46512C16.2877 8.62688 16.3388 8.70776 16.3673 8.8325C16.3888 8.92619 16.3888 9.074 16.3673 9.16768C16.3387 9.29243 16.2873 9.37384 16.1844 9.53668C15.9595 9.89261 15.6166 10.3928 15.1624 10.9353M5.04324 5.03628C3.42169 6.13628 2.32084 7.66453 1.81583 8.46396C1.71321 8.6264 1.66191 8.70762 1.6333 8.83236C1.61182 8.92605 1.61181 9.07383 1.63328 9.16752C1.66187 9.29226 1.71295 9.37313 1.8151 9.53488C2.65916 10.8714 5.17156 14.25 9.00031 14.25C10.5441 14.25 11.8739 13.7007 12.9666 12.9575M2.25031 2.25L15.7503 15.75M7.40932 7.40901C7.00215 7.81618 6.75031 8.37868 6.75031 9C6.75031 10.2426 7.75767 11.25 9.00031 11.25C9.62163 11.25 10.1841 10.9982 10.5913 10.591"
        stroke="#7C88A6"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  label: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8626_15317)">
        <path
          d="M6 6H6.0075M1.5 3.9L1.5 7.25589C1.5 7.62277 1.5 7.80622 1.54145 7.97885C1.57819 8.1319 1.6388 8.27822 1.72104 8.41243C1.8138 8.5638 1.94352 8.69351 2.20294 8.95294L7.95441 14.7044C8.84545 15.5955 9.29097 16.041 9.80471 16.2079C10.2566 16.3547 10.7434 16.3547 11.1953 16.2079C11.709 16.041 12.1545 15.5955 13.0456 14.7044L14.7044 13.0456C15.5955 12.1545 16.041 11.709 16.2079 11.1953C16.3547 10.7434 16.3547 10.2566 16.2079 9.80471C16.041 9.29097 15.5955 8.84545 14.7044 7.95441L8.95294 2.20294C8.69351 1.94352 8.5638 1.8138 8.41243 1.72104C8.27822 1.6388 8.1319 1.57819 7.97885 1.54145C7.80622 1.5 7.62277 1.5 7.25589 1.5L3.9 1.5C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9ZM6.375 6C6.375 6.20711 6.20711 6.375 6 6.375C5.79289 6.375 5.625 6.20711 5.625 6C5.625 5.79289 5.79289 5.625 6 5.625C6.20711 5.625 6.375 5.79289 6.375 6Z"
          stroke="#7C88A6"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8626_15317">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  livestream: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3867 9.88469C17.3867 9.49831 17.5358 9.12684 17.8029 8.84767L20.7092 5.8103L21.0013 5.8103C21.5536 5.8103 22.0013 6.25802 22.0013 6.8103V17.1158C22.0013 17.6681 21.5536 18.1158 21.0013 18.1158H20.7092L17.8313 15.2665C17.5468 14.9847 17.3867 14.6009 17.3867 14.2005V9.88469Z"
        fill="#FF424E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.98831 5.88411C2.88832 5.89054 2 6.78407 2 7.88407V16.1895C2 17.2987 2.90257 18.196 4.01169 18.1895L14.6283 18.1274C15.7282 18.121 16.6166 17.2275 16.6166 16.1275V7.82202C16.6166 6.71288 15.714 5.81557 14.6049 5.82206L3.98831 5.88411ZM7.34472 14.7143L11.8439 11.9168L7.34472 9.1194L7.34472 14.7143Z"
        fill="#FF424E"
      />
    </svg>
  ),
  livestream01: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3002 5.57178V18.3377C23.3002 18.5034 23.1659 18.6377 23.0002 18.6377H22.7377L19.4001 15.3332C19.2484 15.183 19.163 14.9783 19.163 14.7647V9.34044C19.163 9.13438 19.2425 8.93626 19.385 8.78737L22.7489 5.27178H23.0002C23.1659 5.27178 23.3002 5.40609 23.3002 5.57178Z"
        stroke="#00081D"
        strokeWidth="1.4"
      />
      <mask id="path-2-inside-1_8730_25896" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.98855 4.66267C0.888566 4.6691 0.000244141 5.56263 0.000244141 6.66263V17.4285C0.000244141 18.5377 0.902817 19.435 2.01194 19.4285L15.551 19.3494C16.651 19.3429 17.5393 18.4494 17.5393 17.3494V6.5835C17.5393 5.47436 16.6368 4.57705 15.5276 4.58353L1.98855 4.66267ZM7.36404 13.889L9.81864 11.9995L7.36404 10.1099V13.889Z"
        />
      </mask>
      <path
        d="M1.98855 4.66267L1.99674 6.06264L1.98855 4.66267ZM2.01194 19.4285L2.00375 18.0285H2.00375L2.01194 19.4285ZM15.551 19.3494L15.5592 20.7493H15.5592L15.551 19.3494ZM15.5276 4.58353L15.5358 5.98351L15.5276 4.58353ZM9.81864 11.9995L10.6726 13.1089L12.1137 11.9995L10.6726 10.8901L9.81864 11.9995ZM7.36404 13.889H5.96404V16.7335L8.21804 14.9984L7.36404 13.889ZM7.36404 10.1099L8.21804 9.00057L5.96404 7.26545V10.1099H7.36404ZM1.40024 6.66263C1.40024 6.33263 1.66674 6.06457 1.99674 6.06264L1.98037 3.26269C0.110391 3.27362 -1.39976 4.79262 -1.39976 6.66263H1.40024ZM1.40024 17.4285V6.66263H-1.39976V17.4285H1.40024ZM2.00375 18.0285C1.67102 18.0305 1.40024 17.7613 1.40024 17.4285H-1.39976C-1.39976 19.3141 0.134618 20.8395 2.02012 20.8285L2.00375 18.0285ZM15.5428 17.9494L2.00375 18.0285L2.02012 20.8285L15.5592 20.7493L15.5428 17.9494ZM16.1393 17.3494C16.1393 17.6794 15.8728 17.9475 15.5428 17.9494L15.5592 20.7493C17.4292 20.7384 18.9393 19.2194 18.9393 17.3494H16.1393ZM16.1393 6.5835V17.3494H18.9393V6.5835H16.1393ZM15.5358 5.98351C15.8686 5.98156 16.1393 6.25076 16.1393 6.5835H18.9393C18.9393 4.69796 17.405 3.17253 15.5195 3.18355L15.5358 5.98351ZM1.99674 6.06264L15.5358 5.98351L15.5195 3.18355L1.98037 3.26269L1.99674 6.06264ZM8.96465 10.8901L6.51005 12.7797L8.21804 14.9984L10.6726 13.1089L8.96465 10.8901ZM6.51005 11.2193L8.96465 13.1089L10.6726 10.8901L8.21804 9.00057L6.51005 11.2193ZM8.76404 13.889V10.1099H5.96404V13.889H8.76404Z"
        fill="currentColor"
        mask="url(#path-2-inside-1_8730_25896)"
      />
    </svg>
  ),
  manipulation: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2 4.8C10.2 5.79411 11.0059 6.6 12 6.6C12.9942 6.6 13.8 5.79411 13.8 4.8C13.8 3.80589 12.9942 3 12 3C11.0059 3 10.2 3.80589 10.2 4.8Z"
        fill="#7C88A6"
      />
      <path
        d="M10.2 12C10.2 12.9941 11.0059 13.8 12 13.8C12.9942 13.8 13.8 12.9941 13.8 12C13.8 11.0058 12.9942 10.2 12 10.2C11.0059 10.2 10.2 11.0058 10.2 12Z"
        fill="#7C88A6"
      />
      <path
        d="M10.2 19.1999C10.2 20.194 11.0059 20.9999 12 20.9999C12.9942 20.9999 13.8 20.194 13.8 19.1999C13.8 18.2058 12.9942 17.3999 12 17.3999C11.0059 17.3999 10.2 18.2058 10.2 19.1999Z"
        fill="#7C88A6"
      />
    </svg>
  ),
  messenger: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0011 1.99976C10.2643 1.99962 8.55742 2.45182 7.0485 3.31181C5.53959 4.1718 4.28067 5.40995 3.39568 6.90434C2.51069 8.39873 2.03015 10.0978 2.00137 11.8344C1.9726 13.5709 2.39658 15.285 3.23157 16.8079L2.41423 19.6926C2.33799 19.9555 2.3337 20.234 2.40182 20.4991C2.46995 20.7642 2.60798 21.0061 2.80151 21.1996C2.99505 21.3932 3.23698 21.5312 3.50207 21.5993C3.76715 21.6674 4.04566 21.6632 4.30852 21.5869L7.19323 20.7696C8.53008 21.5023 10.0168 21.9197 11.5396 21.9898C13.0625 22.0599 14.5812 21.781 15.9798 21.1742C17.3783 20.5675 18.6196 19.649 19.6088 18.4891C20.598 17.3291 21.309 15.9583 21.6872 14.4815C22.0655 13.0047 22.1012 11.461 21.7914 9.96828C21.4817 8.47559 20.8348 7.07347 19.9002 5.8691C18.9655 4.66472 17.7679 3.68997 16.3989 3.01934C15.0298 2.34871 13.5256 1.99997 12.0011 1.99976ZM17.1647 11.0097L14.0877 14.0867C13.9406 14.2288 13.7441 14.3083 13.5396 14.3083C13.3351 14.3083 13.1385 14.2288 12.9915 14.0867L10.4626 11.5481L7.93364 14.0867C7.78417 14.2093 7.59443 14.272 7.4013 14.2625C7.20818 14.2531 7.02549 14.1721 6.88877 14.0354C6.75204 13.8986 6.67106 13.7159 6.66158 13.5228C6.65209 13.3297 6.71478 13.1399 6.83745 12.9905L9.91447 9.91347C10.0603 9.76901 10.2573 9.68798 10.4626 9.68798C10.6678 9.68798 10.8648 9.76901 11.0107 9.91347L13.5396 12.452L16.0685 9.91347C16.218 9.7908 16.4077 9.72811 16.6008 9.73759C16.794 9.74708 16.9767 9.82806 17.1134 9.96478C17.2501 10.1015 17.3311 10.2842 17.3406 10.4773C17.3501 10.6704 17.2874 10.8602 17.1647 11.0097Z"
        fill="#1A94FF"
      />
    </svg>
  ),
  note: (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9133 2.67676H3.90263C3.55756 2.67676 3.22663 2.81766 2.98264 3.06848C2.73864 3.31929 2.60156 3.65947 2.60156 4.01417V17.3883C2.60156 17.743 2.73864 18.0832 2.98264 18.334C3.22663 18.5848 3.55756 18.7257 3.90263 18.7257H12.7417C12.9125 18.7259 13.0817 18.6912 13.2394 18.6238C13.3971 18.5564 13.5403 18.4575 13.6606 18.3328L17.8321 14.0448C17.9534 13.9211 18.0496 13.7739 18.1152 13.6118C18.1808 13.4497 18.2145 13.2758 18.2143 13.1002V4.01417C18.2143 3.65947 18.0772 3.31929 17.8333 3.06848C17.5893 2.81766 17.2583 2.67676 16.9133 2.67676ZM7.80582 7.3577H13.0101C13.1826 7.3577 13.3481 7.42816 13.4701 7.55356C13.5921 7.67897 13.6606 7.84906 13.6606 8.02641C13.6606 8.20376 13.5921 8.37385 13.4701 8.49926C13.3481 8.62466 13.1826 8.69512 13.0101 8.69512H7.80582C7.63328 8.69512 7.46782 8.62466 7.34582 8.49926C7.22382 8.37385 7.15528 8.20376 7.15528 8.02641C7.15528 7.84906 7.22382 7.67897 7.34582 7.55356C7.46782 7.42816 7.63328 7.3577 7.80582 7.3577ZM10.4079 14.0448H7.80582C7.63328 14.0448 7.46782 13.9743 7.34582 13.8489C7.22382 13.7235 7.15528 13.5534 7.15528 13.3761C7.15528 13.1987 7.22382 13.0286 7.34582 12.9032C7.46782 12.7778 7.63328 12.7074 7.80582 12.7074H10.4079C10.5805 12.7074 10.7459 12.7778 10.8679 12.9032C10.9899 13.0286 11.0585 13.1987 11.0585 13.3761C11.0585 13.5534 10.9899 13.7235 10.8679 13.8489C10.7459 13.9743 10.5805 14.0448 10.4079 14.0448ZM7.80582 11.3699C7.63328 11.3699 7.46782 11.2995 7.34582 11.1741C7.22382 11.0487 7.15528 10.8786 7.15528 10.7012C7.15528 10.5239 7.22382 10.3538 7.34582 10.2284C7.46782 10.103 7.63328 10.0325 7.80582 10.0325H13.0101C13.1826 10.0325 13.3481 10.103 13.4701 10.2284C13.5921 10.3538 13.6606 10.5239 13.6606 10.7012C13.6606 10.8786 13.5921 11.0487 13.4701 11.1741C13.3481 11.2995 13.1826 11.3699 13.0101 11.3699H7.80582ZM13.0101 17.1125V13.3761H16.6449L13.0101 17.1125Z"
        fill="#1E9A98"
      />
    </svg>
  ),
  plus: (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 1V7V13M1.5 7H13.5"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus01: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0002 3.19922V12.7992M3.2002 7.99922H12.8002"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus02: (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49988 3.75V14.25"
        stroke="#191D32"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49988 3.75V14.25"
        stroke="#F4F7FC"
        strokeOpacity="0.8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.24988 9H14.7499"
        stroke="#191D32"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.24988 9H14.7499"
        stroke="#F4F7FC"
        strokeOpacity="0.8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus03: (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5002 3.19922V12.7992M3.7002 7.99922H13.3002"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  printer: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8626_175916)">
        <path
          d="M13.5 5.25V3.9C13.5 3.05992 13.5 2.63988 13.3365 2.31901C13.1927 2.03677 12.9632 1.8073 12.681 1.66349C12.3601 1.5 11.9401 1.5 11.1 1.5H6.9C6.05992 1.5 5.63988 1.5 5.31901 1.66349C5.03677 1.8073 4.8073 2.03677 4.66349 2.31901C4.5 2.63988 4.5 3.05992 4.5 3.9V5.25M4.5 13.5C3.80252 13.5 3.45378 13.5 3.16766 13.4233C2.3912 13.2153 1.78472 12.6088 1.57667 11.8323C1.5 11.5462 1.5 11.1975 1.5 10.5V8.85C1.5 7.58988 1.5 6.95982 1.74524 6.47852C1.96095 6.05516 2.30516 5.71095 2.72852 5.49524C3.20982 5.25 3.83988 5.25 5.1 5.25H12.9C14.1601 5.25 14.7902 5.25 15.2715 5.49524C15.6948 5.71095 16.039 6.05516 16.2548 6.47852C16.5 6.95982 16.5 7.58988 16.5 8.85V10.5C16.5 11.1975 16.5 11.5462 16.4233 11.8323C16.2153 12.6088 15.6088 13.2153 14.8323 13.4233C14.5462 13.5 14.1975 13.5 13.5 13.5M11.25 7.875H13.5M6.9 16.5H11.1C11.9401 16.5 12.3601 16.5 12.681 16.3365C12.9632 16.1927 13.1927 15.9632 13.3365 15.681C13.5 15.3601 13.5 14.9401 13.5 14.1V12.9C13.5 12.0599 13.5 11.6399 13.3365 11.319C13.1927 11.0368 12.9632 10.8073 12.681 10.6635C12.3601 10.5 11.9401 10.5 11.1 10.5H6.9C6.05992 10.5 5.63988 10.5 5.31901 10.6635C5.03677 10.8073 4.8073 11.0368 4.66349 11.319C4.5 11.6399 4.5 12.0599 4.5 12.9V14.1C4.5 14.9401 4.5 15.3601 4.66349 15.681C4.8073 15.9632 5.03677 16.1927 5.31901 16.3365C5.63988 16.5 6.05992 16.5 6.9 16.5Z"
          stroke="#7C88A6"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8626_175916">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  question: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.5C11.866 14.5 15 11.366 15 7.5C15 3.63401 11.866 0.5 8 0.5C4.13401 0.5 1 3.63401 1 7.5C1 11.366 4.13401 14.5 8 14.5Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.167C8.48325 12.167 8.875 11.7752 8.875 11.292C8.875 10.8087 8.48325 10.417 8 10.417C7.51675 10.417 7.125 10.8087 7.125 11.292C7.125 11.7752 7.51675 12.167 8 12.167Z"
        fill="white"
      />
      <path
        d="M7.99967 8.66667V8.08333C8.40348 8.08333 8.79821 7.96359 9.13396 7.73925C9.46971 7.51491 9.7314 7.19605 9.88593 6.82298C10.0405 6.44991 10.0809 6.0394 10.0021 5.64336C9.92333 5.24731 9.72888 4.88352 9.44335 4.59799C9.15782 4.31246 8.79403 4.11801 8.39798 4.03923C8.00194 3.96045 7.59143 4.00088 7.21836 4.15541C6.8453 4.30994 6.52643 4.57163 6.30209 4.90738C6.07775 5.24313 5.95801 5.63786 5.95801 6.04167"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  question01: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.5C11.866 14.5 15 11.366 15 7.5C15 3.63401 11.866 0.5 8 0.5C4.13401 0.5 1 3.63401 1 7.5C1 11.366 4.13401 14.5 8 14.5Z"
        stroke="#808089"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.167C8.48325 12.167 8.875 11.7752 8.875 11.292C8.875 10.8087 8.48325 10.417 8 10.417C7.51675 10.417 7.125 10.8087 7.125 11.292C7.125 11.7752 7.51675 12.167 8 12.167Z"
        fill="#808089"
      />
      <path
        d="M8.00016 8.66667V8.08333C8.40397 8.08333 8.7987 7.96359 9.13445 7.73925C9.4702 7.51491 9.73189 7.19605 9.88642 6.82298C10.0409 6.44991 10.0814 6.0394 10.0026 5.64336C9.92382 5.24731 9.72937 4.88352 9.44384 4.59799C9.15831 4.31246 8.79452 4.11801 8.39847 4.03923C8.00243 3.96045 7.59192 4.00088 7.21885 4.15541C6.84579 4.30994 6.52692 4.57163 6.30258 4.90738C6.07824 5.24313 5.9585 5.63786 5.9585 6.04167"
        stroke="#808089"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  response: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 7.875H5.6325M9 7.875H9.0075M12.375 7.875H12.3825M5.25 13.5V15.2516C5.25 15.6513 5.25 15.8511 5.33192 15.9537C5.40317 16.043 5.5112 16.0949 5.6254 16.0948C5.75672 16.0946 5.91275 15.9698 6.22482 15.7201L8.01391 14.2889C8.37939 13.9965 8.56213 13.8503 8.76561 13.7463C8.94615 13.6541 9.13832 13.5867 9.33691 13.5459C9.56075 13.5 9.79477 13.5 10.2628 13.5H12.15C13.4101 13.5 14.0402 13.5 14.5215 13.2548C14.9448 13.039 15.289 12.6948 15.5048 12.2715C15.75 11.7902 15.75 11.1601 15.75 9.9V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V10.5C2.25 11.1975 2.25 11.5462 2.32667 11.8323C2.53472 12.6088 3.1412 13.2153 3.91766 13.4233C4.20378 13.5 4.55252 13.5 5.25 13.5ZM6 7.875C6 8.08211 5.83211 8.25 5.625 8.25C5.41789 8.25 5.25 8.08211 5.25 7.875C5.25 7.66789 5.41789 7.5 5.625 7.5C5.83211 7.5 6 7.66789 6 7.875ZM9.375 7.875C9.375 8.08211 9.20711 8.25 9 8.25C8.79289 8.25 8.625 8.08211 8.625 7.875C8.625 7.66789 8.79289 7.5 9 7.5C9.20711 7.5 9.375 7.66789 9.375 7.875ZM12.75 7.875C12.75 8.08211 12.5821 8.25 12.375 8.25C12.1679 8.25 12 8.08211 12 7.875C12 7.66789 12.1679 7.5 12.375 7.5C12.5821 7.5 12.75 7.66789 12.75 7.875Z"
        stroke="#7C88A6"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  search: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.505 18.495C17.7784 18.7683 18.2216 18.7683 18.495 18.495C18.7683 18.2216 18.7683 17.7784 18.495 17.505L17.505 18.495ZM14.6283 13.6384C14.3549 13.365 13.9117 13.365 13.6384 13.6384C13.365 13.9117 13.365 14.3549 13.6384 14.6283L14.6283 13.6384ZM18.495 17.505L14.6283 13.6384L13.6384 14.6283L17.505 18.495L18.495 17.505ZM15.5222 9.11111C15.5222 12.6519 12.6519 15.5222 9.11111 15.5222V16.9222C13.4251 16.9222 16.9222 13.4251 16.9222 9.11111H15.5222ZM9.11111 15.5222C5.57035 15.5222 2.7 12.6519 2.7 9.11111H1.3C1.3 13.4251 4.79715 16.9222 9.11111 16.9222V15.5222ZM2.7 9.11111C2.7 5.57035 5.57035 2.7 9.11111 2.7V1.3C4.79715 1.3 1.3 4.79715 1.3 9.11111H2.7ZM9.11111 2.7C12.6519 2.7 15.5222 5.57035 15.5222 9.11111H16.9222C16.9222 4.79715 13.4251 1.3 9.11111 1.3V2.7Z"
        fill="rgb(86, 105, 124)"
      />
    </svg>
  ),
  signOut: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6602 5.65918L16.0011 9.00009L12.6602 12.341"
        stroke="#191D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6602 5.65918L16.0011 9.00009L12.6602 12.341"
        stroke="#F4F7FC"
        strokeOpacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08984 9H15.9989"
        stroke="#191D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08984 9H15.9989"
        stroke="#F4F7FC"
        strokeOpacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.09091 16H2.63636C2.46759 16 2.30573 15.933 2.18639 15.8136C2.06705 15.6943 2 15.5324 2 15.3636V2.63636C2 2.46759 2.06705 2.30573 2.18639 2.18639C2.30573 2.06705 2.46759 2 2.63636 2H7.09091"
        stroke="#191D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.09091 16H2.63636C2.46759 16 2.30573 15.933 2.18639 15.8136C2.06705 15.6943 2 15.5324 2 15.3636V2.63636C2 2.46759 2.06705 2.30573 2.18639 2.18639C2.30573 2.06705 2.46759 2 2.63636 2H7.09091"
        stroke="#F4F7FC"
        strokeOpacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  threeDotsVertical: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 13.875C10.3284 13.875 11 13.2034 11 12.375C11 11.5466 10.3284 10.875 9.5 10.875C8.67157 10.875 8 11.5466 8 12.375C8 13.2034 8.67157 13.875 9.5 13.875Z"
        fill="#191D32"
      />
      <path
        d="M9.5 13.875C10.3284 13.875 11 13.2034 11 12.375C11 11.5466 10.3284 10.875 9.5 10.875C8.67157 10.875 8 11.5466 8 12.375C8 13.2034 8.67157 13.875 9.5 13.875Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
      <path
        d="M9.5 7.875C10.3284 7.875 11 7.20343 11 6.375C11 5.54657 10.3284 4.875 9.5 4.875C8.67157 4.875 8 5.54657 8 6.375C8 7.20343 8.67157 7.875 9.5 7.875Z"
        fill="#191D32"
      />
      <path
        d="M9.5 7.875C10.3284 7.875 11 7.20343 11 6.375C11 5.54657 10.3284 4.875 9.5 4.875C8.67157 4.875 8 5.54657 8 6.375C8 7.20343 8.67157 7.875 9.5 7.875Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
      <path
        d="M9.5 19.875C10.3284 19.875 11 19.2034 11 18.375C11 17.5466 10.3284 16.875 9.5 16.875C8.67157 16.875 8 17.5466 8 18.375C8 19.2034 8.67157 19.875 9.5 19.875Z"
        fill="#191D32"
      />
      <path
        d="M9.5 19.875C10.3284 19.875 11 19.2034 11 18.375C11 17.5466 10.3284 16.875 9.5 16.875C8.67157 16.875 8 17.5466 8 18.375C8 19.2034 8.67157 19.875 9.5 19.875Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
      <path
        d="M14.8496 13.875C15.678 13.875 16.3496 13.2034 16.3496 12.375C16.3496 11.5466 15.678 10.875 14.8496 10.875C14.0212 10.875 13.3496 11.5466 13.3496 12.375C13.3496 13.2034 14.0212 13.875 14.8496 13.875Z"
        fill="#191D32"
      />
      <path
        d="M14.8496 13.875C15.678 13.875 16.3496 13.2034 16.3496 12.375C16.3496 11.5466 15.678 10.875 14.8496 10.875C14.0212 10.875 13.3496 11.5466 13.3496 12.375C13.3496 13.2034 14.0212 13.875 14.8496 13.875Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
      <path
        d="M14.8496 7.875C15.678 7.875 16.3496 7.20343 16.3496 6.375C16.3496 5.54657 15.678 4.875 14.8496 4.875C14.0212 4.875 13.3496 5.54657 13.3496 6.375C13.3496 7.20343 14.0212 7.875 14.8496 7.875Z"
        fill="#191D32"
      />
      <path
        d="M14.8496 7.875C15.678 7.875 16.3496 7.20343 16.3496 6.375C16.3496 5.54657 15.678 4.875 14.8496 4.875C14.0212 4.875 13.3496 5.54657 13.3496 6.375C13.3496 7.20343 14.0212 7.875 14.8496 7.875Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
      <path
        d="M14.8496 19.875C15.678 19.875 16.3496 19.2034 16.3496 18.375C16.3496 17.5466 15.678 16.875 14.8496 16.875C14.0212 16.875 13.3496 17.5466 13.3496 18.375C13.3496 19.2034 14.0212 19.875 14.8496 19.875Z"
        fill="#191D32"
      />
      <path
        d="M14.8496 19.875C15.678 19.875 16.3496 19.2034 16.3496 18.375C16.3496 17.5466 15.678 16.875 14.8496 16.875C14.0212 16.875 13.3496 17.5466 13.3496 18.375C13.3496 19.2034 14.0212 19.875 14.8496 19.875Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
    </svg>
  ),
  trash: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5"
        stroke="#FF424E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  x: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.0003"
        cy="10"
        r="8.33333"
        fill="#7C88A6"
        fillOpacity="0.5"
      />
      <path
        d="M12.5003 7.5L7.50033 12.5M7.50033 7.5L12.5003 12.5M18.3337 10C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 10C1.66699 5.39763 5.39795 1.66667 10.0003 1.66667C14.6027 1.66667 18.3337 5.39763 18.3337 10Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  radio: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.25" stroke="#C8CBD4" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="3.75" fill="#C8CBD4" />
    </svg>
  ),
  check_success: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#1A94FF" />
      <path
        d="M7.625 12.625L10.125 15.125L16.375 8.875"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  up_arrow: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7206_352258)">
        <path
          d="M10.4496 5.68258L14.8246 10.0538C14.9384 10.1716 15.0014 10.3293 15 10.4931C14.9986 10.6568 14.9328 10.8134 14.8169 10.9292C14.7011 11.045 14.5443 11.1106 14.3804 11.1121C14.2166 11.1135 14.0587 11.0506 13.9408 10.9368L10.0077 7.00707L6.07455 10.9368C6.0169 10.9964 5.94794 11.044 5.87168 11.0767C5.79543 11.1095 5.71342 11.1267 5.63043 11.1274C5.54744 11.1281 5.46514 11.1123 5.38833 11.0809C5.31152 11.0495 5.24174 11.0032 5.18306 10.9445C5.12438 10.8859 5.07797 10.8162 5.04654 10.7394C5.01512 10.6627 4.9993 10.5805 5.00002 10.4976C5.00074 10.4146 5.01799 10.3327 5.05074 10.2565C5.0835 10.1803 5.13111 10.1114 5.1908 10.0538L9.56581 5.68258C9.68301 5.56551 9.84195 5.49975 10.0077 5.49975C10.1734 5.49975 10.3324 5.56551 10.4496 5.68258Z"
          fill="#3092E6"
        />
        <path
          d="M10.4496 8.80514L14.8246 13.1764C14.9384 13.2941 15.0014 13.4519 15 13.6156C14.9986 13.7793 14.9328 13.936 14.8169 14.0518C14.7011 14.1675 14.5443 14.2332 14.3804 14.2346C14.2166 14.2361 14.0587 14.1731 13.9408 14.0594L10.0077 10.1296L6.07455 14.0594C6.0169 14.119 5.94794 14.1666 5.87168 14.1993C5.79543 14.232 5.71342 14.2493 5.63043 14.25C5.54744 14.2507 5.46514 14.2349 5.38833 14.2035C5.31152 14.1721 5.24174 14.1257 5.18306 14.0671C5.12438 14.0085 5.07797 13.9387 5.04654 13.862C5.01512 13.7853 4.9993 13.703 5.00002 13.6201C5.00074 13.5372 5.01799 13.4553 5.05074 13.3791C5.0835 13.3029 5.13111 13.234 5.1908 13.1764L9.56581 8.80514C9.68301 8.68807 9.84195 8.62231 10.0077 8.62231C10.1734 8.62231 10.3324 8.68807 10.4496 8.80514Z"
          fill="#3092E6"
        />
      </g>
      <defs>
        <clipPath id="clip0_7206_352258">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 15 15.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  question02: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7010_344936)">
        <path
          d="M9.99613 18.5C14.3809 18.5 18 14.8791 18 10.5C18 6.12089 14.3731 2.5 9.9884 2.5C5.61141 2.5 2 6.12089 2 10.5C2 14.8791 5.61914 18.5 9.99613 18.5ZM9.81054 12.0938C9.30788 12.0938 9.02948 11.8617 9.02948 11.3975V11.3124C9.02948 10.5851 9.44708 10.175 10.0193 9.77273C10.6999 9.30077 11.0324 9.04545 11.0324 8.55029C11.0324 8.01644 10.6225 7.66054 9.9884 7.66054C9.52441 7.66054 9.18415 7.89265 8.92895 8.28723C8.68149 8.56576 8.56549 8.80561 8.1015 8.80561C7.72257 8.80561 7.41324 8.55803 7.41324 8.17118C7.41324 8.01644 7.44418 7.87718 7.49831 7.73791C7.7535 6.97969 8.68149 6.36074 10.0657 6.36074C11.5041 6.36074 12.7182 7.12669 12.7182 8.47292C12.7182 9.40135 12.2078 9.86557 11.4036 10.3839C10.8932 10.7166 10.5993 10.9952 10.5761 11.413C10.5761 11.4362 10.5684 11.4749 10.5684 11.5058C10.5452 11.8385 10.2591 12.0938 9.81054 12.0938ZM9.8028 14.5696C9.27695 14.5696 8.84389 14.1905 8.84389 13.6799C8.84389 13.1692 9.26921 12.7901 9.8028 12.7901C10.3287 12.7901 10.754 13.1692 10.754 13.6799C10.754 14.1983 10.3209 14.5696 9.8028 14.5696Z"
          fill="#1A94FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_7010_344936">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  reload: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 20.9C16.1944 20.9 20 17.0944 20 12.4C20 9.57446 18.6213 7.07093 16.5 5.5254M12.5 22.8L10.5 20.8L12.5 18.8M11.5 3.9C6.80558 3.9 3 7.70558 3 12.4C3 15.2255 4.37867 17.7291 6.5 19.2746M10.5 6L12.5 4L10.5 2"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  link: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6L14 2M14 2H10M14 2L8.66667 7.33333M6.66667 3.33333H5.2C4.0799 3.33333 3.51984 3.33333 3.09202 3.55132C2.71569 3.74307 2.40973 4.04903 2.21799 4.42535C2 4.85318 2 5.41323 2 6.53333V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H9.46667C10.5868 14 11.1468 14 11.5746 13.782C11.951 13.5903 12.2569 13.2843 12.4487 12.908C12.6667 12.4802 12.6667 11.9201 12.6667 10.8V9.33333"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  x01: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#7C8EA0" />
      <path
        d="M12 10.742L18.4821 4.26184C18.5646 4.17924 18.6625 4.11369 18.7703 4.06893C18.8781 4.02418 18.9937 4.00109 19.1104 4.001C19.2272 4.00091 19.3428 4.02381 19.4506 4.06839C19.5585 4.11297 19.6566 4.17837 19.7392 4.26084C19.8218 4.34331 19.8873 4.44124 19.9321 4.54905C19.9768 4.65685 19.9999 4.77242 20 4.88914C20.0001 5.00587 19.9772 5.12147 19.9326 5.22935C19.888 5.33722 19.8226 5.43526 19.7402 5.51786L13.258 12L19.7382 18.4821C19.8208 18.5646 19.8863 18.6625 19.9311 18.7703C19.9758 18.8781 19.9989 18.9937 19.999 19.1104C19.9991 19.2272 19.9762 19.3428 19.9316 19.4506C19.887 19.5585 19.8216 19.6566 19.7392 19.7392C19.6567 19.8218 19.5588 19.8873 19.4509 19.9321C19.3431 19.9768 19.2276 19.9999 19.1109 20C18.9941 20.0001 18.8785 19.9772 18.7707 19.9326C18.6628 19.888 18.5647 19.8226 18.4821 19.7402L12 13.258L5.51786 19.7382C5.43539 19.8208 5.33746 19.8863 5.22965 19.9311C5.12185 19.9758 5.00629 19.9989 4.88956 19.999C4.77283 19.9991 4.65723 19.9762 4.54936 19.9316C4.44148 19.887 4.34344 19.8216 4.26084 19.7392C4.17824 19.6567 4.11269 19.5588 4.06793 19.4509C4.02318 19.3431 4.00009 19.2276 4 19.1109C3.99991 18.9941 4.02281 18.8785 4.06739 18.7707C4.11197 18.6628 4.17737 18.5647 4.25984 18.4821L10.742 12L4.26184 5.51786C4.09501 5.35131 4.00119 5.1253 4.001 4.88956C4.00081 4.65382 4.09428 4.42766 4.26084 4.26084C4.4274 4.09401 4.65341 4.00019 4.88914 4C5.12488 3.99981 5.35104 4.09328 5.51786 4.25984L12 10.742Z"
        fill="white"
      />
    </svg>
  ),
   scriptPost:(
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.89423 6.51919V5.39423H13.3557V6.51919H6.89423ZM6.89423 8.68266V7.55768H13.3557V8.68266H6.89423ZM10.5865 16.125V14.1432L14.6581 10.0904C14.7514 10.0019 14.8524 9.93748 14.961 9.89709C15.0697 9.85672 15.1783 9.83653 15.287 9.83653C15.4033 9.83653 15.517 9.85864 15.6281 9.90287C15.7392 9.94711 15.8389 10.0135 15.9274 10.1019L16.6211 10.8029C16.7019 10.8961 16.7644 10.9971 16.8086 11.1057C16.8528 11.2144 16.875 11.3231 16.875 11.4317C16.875 11.5404 16.856 11.6509 16.818 11.7634C16.78 11.8759 16.7144 11.9788 16.6211 12.0721L12.5682 16.125H10.5865ZM15.287 12.1557L15.9807 11.4317L15.287 10.7307L14.5745 11.4432L15.287 12.1557ZM4.49998 16.125C3.97596 16.125 3.53245 15.9435 3.16946 15.5805C2.80649 15.2175 2.625 14.774 2.625 14.25V12.0865H4.875V1.875H15.375V8.21104C15.1827 8.20046 14.992 8.21224 14.8031 8.24636C14.6142 8.2805 14.4298 8.33699 14.25 8.41584V2.99998H5.99998V12.0865H10.2548L8.94229 13.399V16.125H4.49998Z" fill="#7C88A6"/>
    </svg>
  ),
   messageConfirm:(
     <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M5.63232 14.8513C6.62344 15.4229 7.7734 15.75 8.99973 15.75C12.7277 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 10.2263 2.57703 11.3763 3.14864 12.3674L3.15086 12.3712C3.20586 12.4666 3.23359 12.5147 3.24616 12.5601C3.258 12.603 3.26131 12.6415 3.25828 12.6859C3.25502 12.7336 3.23895 12.783 3.20601 12.8818L2.62939 14.6117L2.62867 14.614C2.50701 14.9789 2.44618 15.1614 2.48954 15.283C2.52734 15.389 2.61126 15.4727 2.71729 15.5105C2.83861 15.5538 3.02028 15.4932 3.38366 15.3721L3.38818 15.3704L5.11804 14.7938C5.21653 14.761 5.2666 14.7443 5.31419 14.7411C5.35856 14.7381 5.39683 14.7421 5.4397 14.7539C5.48526 14.7665 5.53338 14.7942 5.62923 14.8495L5.63232 14.8513Z" stroke="#7C88A6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
     <circle cx="6.02588" cy="8.99951" r="0.759277" fill="#7C88A6"/>
     <circle cx="8.99951" cy="8.99951" r="0.759277" fill="#7C88A6"/>
     <circle cx="11.9731" cy="8.99951" r="0.759277" fill="#7C88A6"/>
     </svg>

    ),
   livestreamProduct: (
     <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M2.25 5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25H12.15C13.4101 2.25 14.0402 2.25 14.5215 2.49524C14.9448 2.71095 15.289 3.05516 15.5048 3.47852C15.75 3.95982 15.75 4.58988 15.75 5.85V9.9C15.75 11.1601 15.75 11.7902 15.5048 12.2715C15.289 12.6948 14.9448 13.039 14.5215 13.2548C14.0402 13.5 13.4101 13.5 12.15 13.5H10.2628C9.79477 13.5 9.56075 13.5 9.33691 13.5459C9.13832 13.5867 8.94615 13.6541 8.76561 13.7463C8.56213 13.8503 8.37939 13.9965 8.01391 14.2889L6.22482 15.7201C5.91275 15.9698 5.75672 16.0946 5.6254 16.0948C5.5112 16.0949 5.40317 16.043 5.33192 15.9537C5.25 15.8511 5.25 15.6513 5.25 15.2516V13.5C4.55252 13.5 4.20378 13.5 3.91766 13.4233C3.1412 13.2153 2.53472 12.6088 2.32667 11.8323C2.25 11.5462 2.25 11.1975 2.25 10.5V5.85Z" stroke="#7C88A6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
       <path d="M10.75 9.75H7.18125L6.30938 4.95625C6.29917 4.89884 6.26923 4.84681 6.22472 4.80914C6.18021 4.77148 6.12393 4.75056 6.06562 4.75H5.5" stroke="#7C88A6" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
       <path d="M7.5 11C7.84518 11 8.125 10.7202 8.125 10.375C8.125 10.0298 7.84518 9.75 7.5 9.75C7.15482 9.75 6.875 10.0298 6.875 10.375C6.875 10.7202 7.15482 11 7.5 11Z" stroke="#7C88A6" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
       <path d="M10.75 11C11.0952 11 11.375 10.7202 11.375 10.375C11.375 10.0298 11.0952 9.75 10.75 9.75C10.4048 9.75 10.125 10.0298 10.125 10.375C10.125 10.7202 10.4048 11 10.75 11Z" stroke="#7C88A6" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
       <path d="M6.95312 8.5H10.8781C10.995 8.50036 11.1082 8.45951 11.198 8.38464C11.2877 8.30977 11.3482 8.20566 11.3688 8.09062L11.75 6H6.5" stroke="#7C88A6" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
     </svg>
   ),
    playVideo:(
           <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
               <rect width="54" height="54" rx="27" fill="#060606" fillOpacity="0.6"/>
               <path d="M19.4434 35.1939V18.8024C19.4434 18.017 20.3073 17.5381 20.9734 17.9544L34.0866 26.1502C34.7133 26.5418 34.7133 27.4545 34.0866 27.8462L20.9734 36.0419C20.3073 36.4582 19.4434 35.9794 19.4434 35.1939Z" fill="white"/>
           </svg>

       )
}
